import React, { createContext, useContext, useEffect, useState } from "react";
import { getTag } from "../api/tagApi";
import { ToastDisplayer } from "../components/toastDisplay/ToastDisplayer";

const TagContext = createContext();

export const TagProvider = ({ children }) => {
  const [tagList, setTagList] = useState([]);
  const [loadingTags, setLoadingTags] = useState(false);

  const fetchTags = async () => {
    try {
      setLoadingTags(true);

      const res = await getTag();

      if (res.success) {
        setTagList(res.data?.data || res.data || []);
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to fetch tags.",
      );
    } finally {
      setLoadingTags(false);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  return (
    <TagContext.Provider
      value={{
        tagList,
        loadingTags,
        fetchTags,
      }}
    >
      {children}
    </TagContext.Provider>
  );
};

export const useTags = () => {
  return useContext(TagContext);
};
